import { FunctionComponent } from "react"
import SidebarContents from "./sidebar-contents"

const SidebarOpen: FunctionComponent = () => {
  return <SidebarContents isOpen={true} />
}

export default SidebarOpen
